import createStore from "astrid-helpers/src/createStore";

import { version } from "../../../../package.json";

import useHasRight from "../../authorization/hooks/useHasRight";

const storageKey = "whatsNewSeen";

export const currentRelease = version.split(".").slice(0, 2).join(".");

export const [getWhatsNewSeen, setWhatsNewSeen, useWhatsNewSeen, onWhatsNewSeen] = createStore(
	localStorage.getItem(storageKey),
);

onWhatsNewSeen((seen) => localStorage.setItem(storageKey, seen));

export function useWhatsNewUnseen() {
	const hasRight = useHasRight();
	const seen = useWhatsNewSeen();

	return hasRight("whatsNew.view") && seen !== currentRelease;
}
